import { styled, Typography, TypographyProps } from "@mui/material";

export const BodyText = styled((props: TypographyProps) => (<Typography { ...props } variant="body1" />))(({ theme }) => ({
	color: 'rgba(255, 255, 255, 0.6)'
}));

export const HeadingText1 = styled((props: TypographyProps) => (<Typography { ...props } variant="h4" />))(({ theme }) => ({
	color: theme.palette.primary.contrastText
}));

export const HeadingText2 = styled((props: TypographyProps) => (<Typography { ...props } variant="h5" />))(({ theme }) => ({
	color: theme.palette.primary.contrastText
}));
